import { amenities } from "../data/amenities";
import { motion } from "framer-motion";

export default function AmenitiesSection() {
    return (
        <section className="py-32 bg-white dark:bg-[#1a1a1a] scroll-mt-24">
            <div className="max-w-7xl mx-auto px-6">

                {/* Heading */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="text-center mb-16"
                >
                    <div className="relative inline-block">
                        <span className="absolute inset-0 blur-3xl bg-gold/10 rounded-full"></span>
                        <h2 className="relative text-4xl font-serif text-gold">
                            Amenities & Services
                        </h2>
                    </div>
                    <p className="mt-4 text-charcoal/70 dark:text-ivory/70 max-w-2xl mx-auto">
                        Thoughtfully curated amenities designed to offer comfort,
                        convenience, and a refined living experience.
                    </p>
                </motion.div>

                {/* Amenities Grid */}
                <div className="bg-ivory/70 dark:bg-black/40 backdrop-blur-md rounded-3xl px-10 py-20 shadow-xl">
                    <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-10">
                        {amenities.map((item, index) => {
                            const Icon = item.icon;

                            return (
                                <motion.div
                                    key={index}
                                    className="p-8 rounded-3xl bg-white/80 dark:bg-charcoal/60 backdrop-blur-md border border-gold/20 hover:border-gold shadow-lg hover:shadow-xl transition"
                                >
                                    <Icon className="text-gold mb-4" size={28} />

                                    <h3 className="text-xl font-serif text-gold">
                                        {item.title}
                                    </h3>

                                    <p className="mt-3 text-sm text-charcoal/70 dark:text-ivory/70">
                                        {item.description}
                                    </p>
                                </motion.div>
                            );
                        })}

                    </div>
                </div>

            </div>
        </section>
    );
}